export class Score {
  constructor({ animate, preview, update, animateOff }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.name = "Score";
    this.scene = "Score Update";
    this.data = [];
  }

  async preview({ options }) {
    this.onAir = false;
    this.options = options;
    this.data = [];

    this.data.push({
      name: "Home Team Name",
      value: {
        text: options?.game?.home_team?.name,
      },
    });
    this.data.push({
      name: "Home Team Short Name",
      value: {
        text: options?.game?.home_team?.short_name,
      },
    });
    this.data.push({
      name: "Home Team Badge",
      value: {
        image:
          "${user}" + options?.game?.home_team?.variables?.hyper_badge || "",
      },
    });
    this.data.push({
      name: "Home Team Secondary Badge",
      value: {
        image: "${user}" + options?.game?.home_team?.variables?.alt_badge || "",
      },
    });
    this.data.push({
      name: "Home Team Third Badge",
      value: {
        image:
          "${user}" + options?.game?.home_team?.variables?.third_badge || "",
      },
    });
    this.data.push({
      name: "Away Team Name",
      value: {
        text: options?.game?.away_team?.name,
      },
    });
    this.data.push({
      name: "Away Team Short Name",
      value: {
        text: options?.game?.away_team?.short_name,
      },
    });
    this.data.push({
      name: "Away Team Badge",
      value: {
        image:
          "${user}" + options?.game?.away_team?.variables?.hyper_badge || "",
      },
    });
    this.data.push({
      name: "Away Team Secondary Badge",
      value: {
        image: "${user}" + options?.game?.away_team?.variables?.alt_badge || "",
      },
    });
    this.data.push({
      name: "Away Team Third Badge",
      value: {
        image:
          "${user}" + options?.game?.away_team?.variables?.third_badge || "",
      },
    });

    let home_score = 0;
    let away_score = 0;

    if (options.period >= 1) {
      home_score += parseInt(options?.game?.scores_by_quarter?.home?.first);
      away_score += parseInt(options?.game?.scores_by_quarter?.away?.first);
    }
    if (options.period >= 2) {
      home_score +=
        parseInt(options?.game?.scores_by_quarter?.home?.second) || 0;
      away_score += parseInt(
        options?.game?.scores_by_quarter?.away?.second || 0
      );
    }
    if (options.period >= 3) {
      home_score += parseInt(
        options?.game?.scores_by_quarter?.home?.third || 0
      );
      away_score += parseInt(
        options?.game?.scores_by_quarter?.away?.third || 0
      );
    }
    if (options.period >= 4) {
      home_score += parseInt(
        options?.game?.scores_by_quarter?.home?.fourth || 0
      );
      away_score += parseInt(
        options?.game?.scores_by_quarter?.away?.fourth || 0
      );
    }
    if (options.period >= 5) {
      home_score += parseInt(options?.game?.scores_by_quarter?.home?.fith || 0);
      away_score += parseInt(options?.game?.scores_by_quarter?.away?.fith || 0);
    }

    this.data.push({
      name: "Home Score",
      value: {
        text: home_score || "0",
      },
    });
    this.data.push({
      name: "Home Score",
      value: {
        text: away_score || "0",
      },
    });

    this.data.push({
      name: "Subtitle",
      value: {
        text: options.subtitle,
      },
    });
    this.sendPreview(this.scene, 500, this.data, "IN");
  }
  animate({ options }) {
    this.onAir = true;

    this.sendAnimate(this.scene, this.data);
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff(this.scene, []);
  }
}
